import { render, staticRenderFns } from "./BrandCrisis.vue?vue&type=template&id=78a62ff7&scoped=true&"
import script from "./BrandCrisis.vue?vue&type=script&lang=js&"
export * from "./BrandCrisis.vue?vue&type=script&lang=js&"
import style0 from "./BrandCrisis.vue?vue&type=style&index=0&id=78a62ff7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a62ff7",
  null
  
)

export default component.exports